var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9156_12895)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9156_12895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9156_12895)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9156_12895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9156_12895)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9156_12895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9156_12895)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9156_12895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9156_12895)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9156_12895",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9156_12895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0824 8.23234C14.2487 8.13037 15.112 7.10187 15.0093 5.93553C14.9081 4.76915 13.8796 3.90621 12.7132 4.00818C11.5468 4.11018 10.6836 5.13831 10.7855 6.30468C10.8876 7.47178 11.916 8.33434 13.0824 8.23234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7276 16.6988C13.2234 16.8833 12.3738 17.4033 12.3738 17.4033C12.3738 17.4033 13.018 14.4253 13.0446 14.2956C13.3168 12.9885 14.0903 11.1438 13.0425 10.0223C12.3128 9.24305 11.3748 9.45277 10.5481 10.2435C10.0023 10.7653 9.71284 11.0989 9.20725 11.6598C9.00256 11.8871 8.925 12.0994 9.02193 12.4322C9.12606 12.7921 9.54693 12.9706 9.91897 12.8345C10.4232 12.6502 11.2721 12.1303 11.2721 12.1303C11.2721 12.1303 10.8785 13.9427 10.6824 14.849C10.6551 14.9783 9.55556 18.3894 10.6042 19.5109C11.3338 20.2906 12.2711 20.0805 13.0985 19.2901C13.6443 18.7683 13.9338 18.4347 14.4394 17.8734C14.6441 17.6464 14.7209 17.4342 14.6247 17.1013C14.5198 16.7419 14.0997 16.563 13.7276 16.6988Z",
    fill: "white"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9156_12895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.95af874e80a4eedb279d211a54a4aceb.svg";
export { ForwardRef as ReactComponent };